import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, Event, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  public sideNav?: MatSidenav;
  public currentUrl = new BehaviorSubject<string>('');
  private scrollTo$: Subject<'top' | 'bottom'> = new Subject<
    'top' | 'bottom'
  >();

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
        this.scrollSideNavTo('bottom');
      }
    });
  }

  get scrollTo(): Observable<string> {
    return this.scrollTo$.asObservable();
  }

  scrollSideNavTo(direction: 'top' | 'bottom'): void {
    this.scrollTo$.next(direction);
  }

  public open(): void {
    this.sideNav?.open();
  }

  public close(): void {
    this.sideNav?.close();
  }
}
